<template>
    <print-layout>
        <div class="print-container">
            <div>
                <div class="text-4xl">
                    <span class="text-green"><b>PRODUCE</b></span>
                    <span class="ml-2 text-red"><b>EXPRESS</b></span>
                </div>

                <table>
                    <div class="text-muted h5" style="padding:5px">Routific Summary</div>
                    <thead>
                        <tr>
                            <td class="text-left">Total Orders</td>
                            <td>{{ count(orders) }}</td>
                        </tr>
                        <tr>
                            <td class="text-left">Total Items</td>
                            <td>{{ items.sum('total_quantity') }}</td>
                        </tr>
                    </thead>
                </table>

                <table class="w-4/5">
                    <tbody class="striped">
                        <tr class="not_striped border-b border-gray">
                            <th class="text-left">Item</th>
                            <th class="text-left">Unit</th>
                            <th class="text-right">Qty</th>
                        </tr>
                        <template v-for="(item, index) in items" :key="index">
                            <!-- Parent Item -->
                            <tr class="border-b border-gray">
                                <td>{{ item.title }} {{ item.description_alt }}</td>
                                <td>{{ item.description }}</td>
                                <td>{{ item.total_quantity }}</td>
                            </tr>
                        </template>
                    </tbody>
                </table>
            </div>
        </div>
    </print-layout>
</template>

<script>
import PrintLayout from '@/Layouts/PrintLayout.vue';

export default {
    components: {
        PrintLayout,
    },

    props: ['orders', 'items'],

    methods: {
    },

    mounted () {
        window.print();

        window.onafterprint = function() {
            window.close();
        };
        window.onfocus = function() {
            window.close();
        };
    }
}

</script>

<style>
    body {
        font-size: 90%;
        height: 100%;
    }

    table {
        width: 100%;
    }

    table td {
        -webkit-print-color-adjust: exact;
    }

    .combo_with_integrated_subitems {
        background-color: #EEEEEE;
        color: #515558!important;
    }

    .page-break {
        page-break-after: always;
    }

    .subheader th {
        background: #cbcbcb;
        -webkit-print-color-adjust: exact;
    }

    .signature {
        @apply border-r-0 border-l-0 border-t-0 border-b border-gray-dark !important;
    }

    .footer {
        position: fixed;
        bottom: 0px;
        left: 0px;
        width: 100%;
    }

    @media screen {
        .print-container {
            display: none;
        }
    }

    .striped tr:nth-child(even):not(.not_striped) {
        background-color: #f2f2f2;
    }
</style>
